var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"z-index":10,"value":_vm.alert.showLoading,"align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}}),_c('div',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.alert.messageLoading))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }